// Desktop sidebar collapse toggle. Flips the `sidebar-collapsed` class on <html>
// (the CSS in application.tailwind.css shrinks the rail to icons) and remembers the
// choice in a cookie so the server can render the collapsed state on the next load
// with no flash. Mobile keeps the DaisyUI drawer; the collapse CSS is lg-only.

function setCollapsed(collapsed) {
  document.documentElement.classList.toggle("sidebar-collapsed", collapsed);
  document.cookie = `sidebar_collapsed=${collapsed ? "1" : "0"}; path=/; max-age=31536000; samesite=lax`;
}

function bindSidebarToggle() {
  const btn = document.querySelector("[data-sidebar-toggle]");
  if (!btn || btn.dataset.bound) return;
  btn.dataset.bound = "true";
  btn.addEventListener("click", () => {
    setCollapsed(!document.documentElement.classList.contains("sidebar-collapsed"));
  });
}

document.addEventListener("turbo:load", bindSidebarToggle);
document.addEventListener("DOMContentLoaded", bindSidebarToggle);
